import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Partner} from '../../models/partner';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends AbstractModelService<Partner> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner', Partner);
  }
}
